import styled from 'styled-components';

export interface WrapProps {
  width?: string
  height?: string
  bgColor?: string
  borderWidth?: number
  borderColor?: string
}

export const AvatarWrapper = styled.div<WrapProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  width: ${props => props.width};
  height: ${props => props.height};
  background-color: ${props => props.bgColor || props.theme.colors.avatarBgColor || '#cccccc'};
  overflow: hidden;
  border: ${props => `${props.borderWidth}px solid ${props.theme.colors[props.borderColor] || props.borderColor}`};

  img {
    max-width: 100%;
    min-width: ${props => props.width};
  }
`;

export const Avatar = styled.div`
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
`;
